import React from 'react';

import cn from 'classnames';

import styles from './Pill.module.css';

export type PillProps = {
  children?: React.ReactNode;
  variant?: 'green' | 'london' | 'yellow' | 'red';
  size?: 'small' | 'medium' | 'large';
} & React.HTMLAttributes<HTMLDivElement>;

export const Pill = ({
  children,
  variant = 'london',
  size = 'small',
  className,
  ...pillProps
}: PillProps) => {
  return (
    <div
      className={cn(styles.pill, styles[variant], styles[size], className)}
      {...pillProps}
    >
      {children}
    </div>
  );
};
